import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToastModule } from 'primeng/toast';
import { Stats } from 'src/app/models/Stats';
import { entite } from 'src/app/models/entite';
import { entiteAdd } from 'src/app/models/entiteAdd';
import { formejuridique } from 'src/app/models/formjuridique';
import { typeSociete } from 'src/app/models/typeSociete';
import { EntitebackService } from 'src/app/services/entite/entiteback.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-form-entite',
  templateUrl: './form-entite.component.html',
  imports: [CommonModule,FormsModule,ToastModule,ButtonModule,ReactiveFormsModule,InputTextModule,SelectButtonModule,SelectModule,ButtonModule,RadioButtonModule],
  styleUrls: ['./form-entite.component.scss']
})
export class FormEntiteComponent implements OnInit {
  libelleselected: string = '';
  entites!: entite[];
  formjuridlis!: formejuridique[];
  selectedFormejurid!: formejuridique;
  selectedExterne: any;
  selectedAdress1: any;
  selectedCodePostal: any;
  selectedVille: any;
  selectedAdress2: any;
  selectedAdress3: any;
  selectedstats!: any;
  statusActifInactif: Stats[] = [
    {
      libelle: 'Actif',
      value: 1
    },

    {
      libelle: 'Inactif',
      value: 0
    }];
  selectedTel!: any;


  constructor(public root: Router, public messageService: MessageService, public shared: shareOpeSevices, private fb: FormBuilder, private entiteservice: EntitebackService) {
    this.monentite = new entiteAdd();
  };
  monentite!: entiteAdd;
  selectedEntitePere!: entite;
  typesciete!: typeSociete[];
  selecteTypesociete!: typeSociete;
  ngOnInit() {

    this.entiteservice.getAllEntites().subscribe((data: entite[]) => {
      this.entites = data;
    });
    this.entiteservice.getTypeSociete().subscribe((data: typeSociete[]) => {
      this.typesciete = data;
    });
    this.entiteservice.getFormjuridique().subscribe((data: formejuridique[]) => {
      this.formjuridlis = data;
    });
  }


  entiteForm = this.fb.group({
    nomentite: ['', Validators.required],
    num_pere: [0, Validators.required],
    type: [""],
    adress1: ['', Validators.required],
    adress2: [''],
    adress3: [''],
    ext: [''],
    telephone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    formeJuridique: [''],
    codepostal: [0, { validators: [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')] }],
    ville: ['', Validators.required],
    statuts: [1]
  });

  addEntite() {

    this.entiteForm.value.formeJuridique = this.selectedFormejurid?.libelle;
    this.entiteForm.value.type = this.selecteTypesociete?.a1CODE;
    this.monentite.libelle = this.libelleselected;
    this.monentite.adresse1 = this.selectedAdress1;
    this.monentite.adresse2 = this.selectedAdress2;
    this.monentite.adresse3 = this.selectedAdress3;
    this.monentite.ext = this.selectedExterne;
    this.monentite.ville = this.selectedVille;
    this.monentite.num_pere = this.selectedEntitePere?.numEntite;
    this.monentite.type = this.selecteTypesociete?.a1CODE;
    this.monentite.formeJuridique = this.selectedFormejurid?.a1code;
    this.monentite.code_postal = this.selectedCodePostal;
    this.monentite.statut = this.entiteForm.value.statuts == 0 ? 0 : 1;
    this.monentite.tel = this.selectedTel;

    this.entiteservice.addEntite(this.monentite).subscribe({

      next: (response: any) => {

        if (response.status == 200 && response.body !== null) {

          this.messageService.add({ severity: 'success', detail: response.body?.libelle + ' a été ajoutée avec succés' });
          this.entiteForm.reset();
        }

        else if (response.body === null) {

          this.messageService.add({ severity: 'warn', detail: "Entité existe dèja !" });
        }
      },
      error: (err: HttpErrorResponse) => {

        this.messageService.add({ severity: 'warn', detail: err.error.message + ' Erreur' });

      }

    })

  }



}
